<script>

    export default {
        name: 'Newsletter',
        data() {
            return {
                email: '',
                emailString: '',
                formSuccess: false,
                formMessage: '',
                loading: false,
                currentLang: window.lang || 'en',
            };
        },
        methods: {
            sendData() {
                this.loading = true
                if (!this.errors.has('email') && this.emailString.length) {
                    this.$jsonp('https://dezentrum.us17.list-manage.com/subscribe/post-json?u=7f5ec7a3276754731c4026229&id=1fd73e0aaa', {
                        EMAIL: this.emailString,
                        callbackQuery: 'c',
                        callbackName: 'jsonpFunc',
                    }).then((json) => {
                        this.loading = false
                        if (json.result === 'success') {
                            this.formSuccess = true;
                            this.formMessage = json.msg;
                        } else {
                            this.formSuccess = false;
                            this.formMessage = json.msg;
                        }
                    });
                } else {
                    this.loading = false;
                }
            },
        },
    };
</script>
